import { c as _c } from "react/compiler-runtime";
import useMediaQuery from '@/hooks/useMediaQuery';
import { MotionValue, useMotionValueEvent, useScroll, useTransform } from 'framer-motion';
import { getMediaQuery } from '@/styles/sizes';
import { useClientOnly } from '@/hooks/useClientOnly';
import { SetState } from '@/utils/types';
function getMaxTransformation(totalCards: number = 4, index: number): number {
  const max = 1;
  const implicit = 0.1;
  return max - (totalCards - index) * implicit + implicit;
}
interface CardScrollOptions {
  totalCards: number;
  index: number;
  setActiveTab: SetState<number>;
  ref: React.RefObject<HTMLDivElement | null>;
}
export function useCardScroll(options) {
  const $ = _c(17);
  const {
    totalCards,
    index,
    setActiveTab,
    ref
  } = options;
  const {
    isClient
  } = useClientOnly();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getMediaQuery("lg");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isDesktop = useMediaQuery(t0);
  const t1 = isClient ? ref : undefined;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["500px start", "end end"];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1) {
    t3 = {
      target: t1,
      offset: t2
    };
    $[2] = t1;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    scrollYProgress
  } = useScroll(t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [0, 1];
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== index || $[6] !== totalCards) {
    t5 = getMaxTransformation(totalCards, index);
    $[5] = index;
    $[6] = totalCards;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = [t5, 1];
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const transform = useTransform(scrollYProgress, t4, t6);
  let t7;
  if ($[10] !== index || $[11] !== setActiveTab || $[12] !== totalCards) {
    t7 = latest => {
      if (latest > 0 && latest < 1) {
        setActiveTab(oldActiveTab => {
          if (oldActiveTab === index || oldActiveTab === index - 1 || oldActiveTab === index + 1) {
            return index;
          }
          return oldActiveTab;
        });
      } else {
        if (latest === 1) {
          setActiveTab(0);
        } else {
          if (latest === 0) {
            setActiveTab(totalCards - 1);
          }
        }
      }
    };
    $[10] = index;
    $[11] = setActiveTab;
    $[12] = totalCards;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  useMotionValueEvent(scrollYProgress, "change", t7);
  const t8 = !isDesktop && isClient;
  let t9;
  if ($[14] !== t8 || $[15] !== transform) {
    t9 = {
      isMobile: t8,
      transform
    };
    $[14] = t8;
    $[15] = transform;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}